// Is a given value equal to null?
export default function isNull(obj) {
  return obj === null;
}



//////////////////
// WEBPACK FOOTER
// ./~/backbone/~/underscore/modules/isNull.js
// module id = 497
// module chunks = 8